// Source: app/scripts/controllers/authorization-types-controller.js
Auction.controller('AuthorizationTypesController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  function ($scope, $filter, $routeParams, $location, toaster, crudService, $modal, Downloader, Messages) {


    // $scope.downloadDocument = function () {
    //   if ($scope.chosenDocument.id) {
    //     Downloader.download('/data/rest/portal_attachments/get/' + $scope.chosenDocument.id);
    //   }
    // };


    $scope.modalAddOrEditCaseDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_authorization_type_template.html',
      show: false
    });

    $scope.addAuthorizationTypeAttachment = function(authorizationType){
    console.log('tuka sum ');
    };
    // $scope.crudScope.addAuthorizationTypeAttachment = function(authorizationType){
    //   console.log('tuka sum vo crud');
    // };

    // $scope.changeAttachmentForDocument = function () {
    //   if ($scope.chosenDocument.id) {
    //     $scope.portalDocument = $scope.chosenDocument;
    //     $scope.modalAddOrEditCaseDocument.show();
    //   }
    // };

    // $scope.savePortalDocument = function () {
    //   caseService.getPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
    //     $scope.documentList = data;
    //   });
    //   $scope.modalAddOrEditCaseDocument.hide();
    //
    //   $scope.portalDocument = {};
    //
    // };
    //
    // $scope.showAddNewDocumentForm = function () {
    //   $scope.portalDocument = {};
    //   $scope.modalAddOrEditCaseDocument.show();
    // };

    $scope.afterInit = function (crudScope) {

      crudScope.addAuthorizationTypeAttachment = function(authorizationType){
        console.log('tuka sum vo crud 2');
        $scope.authorizationType = authorizationType;
        $scope.modalAddOrEditCaseDocument.show();
      };

      crudScope.downloadAuthorizationTypeTemplateAttachment = function (templateId) {
        if(templateId) {
          Downloader.download('/data/rest/portal_attachments/get_authorization_type_template/' + templateId);
        }
      };
    }

  }
]);
